import { cn } from '@/lib/utils';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

const Switch = React.forwardRef<
    React.ElementRef<typeof SwitchPrimitives.Root>,
    React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
        size?: 'sm' | 'default';
        // Overrides the checked-state background (e.g. 'data-[state=checked]:bg-blue-500').
        // Falls back to the default primary color when omitted.
        checkedClassName?: string;
    }
>(({ className, size = 'default', checkedClassName, ...props }, ref) => (
    <SwitchPrimitives.Root
        className={cn(
            'peer inline-flex items-center data-[state=unchecked]:bg-input disabled:opacity-50 border-2 border-transparent rounded-full focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background transition-colors cursor-pointer disabled:cursor-not-allowed shrink-0',
            checkedClassName ?? 'data-[state=checked]:bg-foreground',
            size === 'sm' ? 'w-8 h-5' : 'w-11 h-6',
            className
        )}
        {...props}
        ref={ref}
    >
        <SwitchPrimitives.Thumb
            className={cn(
                'block bg-background data-[state=unchecked]:bg-white shadow-lg rounded-full ring-0 transition-transform data-[state=unchecked]:translate-x-0 pointer-events-none',
                size === 'sm'
                    ? 'w-3.5 h-3.5 data-[state=checked]:translate-x-3.5'
                    : 'w-5 h-5 data-[state=checked]:translate-x-5'
            )}
        />
    </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
